var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineBitcoinConvert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.35 23.34a.745.745 0 0 1 .01-.75l1.05-1.75c.21-.36.67-.47 1.03-.26.36.21.47.67.26 1.03l-.27.45c2.76-.65 4.83-3.13 4.83-6.09 0-.41.34-.75.75-.75s.75.34.75.75c-.01 4.27-3.49 7.75-7.76 7.75-.27 0-.52-.15-.65-.38zM.25 7.97C.25 3.7 3.73.22 8 .22a.745.745 0 0 1 .64 1.13L7.59 3.1c-.21.36-.67.47-1.03.26a.749.749 0 0 1-.26-1.03l.27-.45c-2.76.65-4.83 3.13-4.83 6.09a.74.74 0 0 1-.74.75c-.41 0-.75-.34-.75-.75z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.621 16.08c-.41 0-.75-.34-.75-.75v-2.25c0-.41.34-.75.75-.75h2.81c1 0 1.88.88 1.88 1.88 0 1.02-.85 1.87-1.88 1.87h-2.81zm2.81-1.5c.21 0 .38-.17.38-.38 0-.15-.17-.38-.38-.38h-2.06v.76h2.06z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.61 18.33c-.41 0-.75-.34-.75-.75v-2.25c0-.41.34-.75.75-.75h3.22c1.12 0 2.04.84 2.04 1.88s-.91 1.87-2.04 1.87H6.61zm3.23-1.5c.32 0 .54-.2.54-.38s-.22-.38-.54-.38H7.37v.76h2.47z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.67 18.7v-1.13c0-.41.34-.75.75-.75s.75.34.75.75v1.13a.749.749 0 1 1-1.5 0zM7.67 13.07v-1.13c0-.41.34-.75.75-.75s.75.34.75.75v1.13a.749.749 0 1 1-1.5 0z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.75 15.33c0-3.81 3.11-6.92 6.92-6.92.18 0 .34.01.52.02 3.39.26 6.13 3 6.38 6.37.01.22.02.37.02.53.01 3.81-3.1 6.92-6.92 6.92s-6.92-3.11-6.92-6.92zm1.5-.01c0 2.99 2.43 5.42 5.42 5.42 2.99 0 5.43-2.43 5.43-5.42 0-.13-.01-.26-.02-.39-.2-2.68-2.35-4.82-4.99-5.02-.13 0-.27-.01-.42-.01-2.99 0-5.42 2.43-5.42 5.42z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.84 15.6c-.39 0-.72-.3-.75-.69A5.44 5.44 0 0 0 9.1 9.92a.752.752 0 0 1-.69-.75v-.49c0-3.82 3.11-6.92 6.93-6.92s6.92 3.11 6.92 6.92-3.12 6.92-6.93 6.92h-.49zm.65-1.5a5.432 5.432 0 0 0 5.26-5.42c0-2.99-2.43-5.42-5.42-5.42A5.419 5.419 0 0 0 9.9 8.51c2.82.51 5.08 2.76 5.59 5.59z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineBitcoinConvert);
export default __webpack_public_path__ + "static/media/vuesax-outline-bitcoin-convert.5c803a570d0bf742cf3023560732d240.svg";
export { ForwardRef as ReactComponent };